module.exports = __webpack_public_path__ + "static/media/material-adv-logo.7d1593f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/material/material-adv-logo.png
// module id = 1107
// module chunks = 114